import { MantineThemeOverride } from '@mantine/core';

export type PaginationTheme = NonNullable<MantineThemeOverride['components']>['Pagination'];

export const Pagination: PaginationTheme = {
  // todo: define
};
